import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const madeiraBeachConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Madeira Beach Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Madeira Beach, FL. Sam\'s Tree Service handles dangerous coastal trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_madeira_beach',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Madeira Beach',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Madeira Beach Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring dependable tree care to the 
     homes and businesses of <strong>Madeira Beach</strong>. This Gulf front community 
     is no stranger to storm activity, and the trees here take a beating season after 
     season. Salt exposure weakens trunks, wind pushes canopies off balance, and heavy 
     rain saturates root systems turning healthy trees into serious hazards for nearby 
     structures and parked boats. Our team handles it all.`,

    `We specialize in <strong>hazardous coastal tree removal and trimming</strong>
     storm damaged palms, overgrown canopies near vacation homes and docks, large 
     limbs hanging over seawalls, and trees with structural compromise that need 
     full removal before the next storm season. We work fast, work safely, and 
     leave your property clean.`,

    `<strong>Sam's Tree Service</strong> provides expert, professional tree care 
     throughout <strong>Madeira Beach</strong> and the surrounding <strong>Pinellas 
     Gulf beach</strong> communities protecting your property and landscape 
     no matter what the season brings.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Madeira Beach, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_MadeiraBeach = () => <LocationPage config={madeiraBeachConfig} />;
export default Services_MadeiraBeach;
